import PropTypes from 'prop-types';
import React from 'react';

import './LeftDrawerFooter.scss';
import Menu from '../../Header/Modules/Menu/Menu';
import FGBLogoCopyrightDisplay from '../Components/FGBLogoCopyrightDisplay/FGBLogoCopyrightDisplay';
import SocialMediaDisplay from '../Components/SocialMediaDisplay/SocialMediaDisplay';
import { pageDisplayModePropTypes } from '../../../../pages/defaultProps';
import { PAGE_DISPLAY_MODE } from '../../../../pages/constants';

export default class LeftDrawerFooter extends React.PureComponent {
    static propTypes = {
        /**
         * Number of social media likes
         */
        socialLikes: PropTypes.object.isRequired,
        /**
         * meta data for social icons
         */
        socialIcons: PropTypes.array.isRequired,
        /**
         * footer's menu for navigation
         */
        footerMenuItems: PropTypes.array.isRequired,
        /**
         * Value of the view layout the page is in
         */
        pageDisplayMode: pageDisplayModePropTypes.isRequired,
    };

    static defaultProps = {
        footerMenuItems: [],
        socialIcons: [],
        socialLikes: {
            facebook: '',
            linkedIn: '',
            instagram: '',
            twitter: '',
        },
        featureFlags: {},
    };

    render() {
        const {
            footerMenuItems,
            socialIcons,
            socialLikes,
            pageDisplayMode,
            featureFlags,
        } = this.props;
        const hideSocialMediaIcons =
            pageDisplayMode === PAGE_DISPLAY_MODE.EMPLOYER_DEFAULT;
        const hideSocialMediaIconStyle = hideSocialMediaIcons
            ? 'social-media-copyright--start-bottom'
            : '';

        return (
            <div className="component-Layout-Footer-LeftDrawerFooter">
                <Menu
                    menuItems={footerMenuItems}
                    cssClass="drawer-footer-items"
                />

                <div
                    className={`social-media-copyright ${hideSocialMediaIconStyle}`}
                >
                    {!hideSocialMediaIcons && (
                        <SocialMediaDisplay
                            socialIcons={socialIcons}
                            socialLikes={socialLikes}
                        />
                    )}

                    <FGBLogoCopyrightDisplay />
                </div>
            </div>
        );
    }
}
